// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2D5xg","footer":"styles_footer__2gJUb","passCodeTooltip":"styles_passCodeTooltip__3FJof"};